import Signal from 'libs/signals';

const edoFundingDisbursementSignal = Signal({
  record: null,
  createTransactionModalOpen: false,
  onTransactionCreatedCallback: null,
});

export const edoFundingTransactionAddTransactionFormSignal = Signal({
  amount: '',
  date: '',
  time: 0,
  memo: '',
  attachments: [],
});

export default edoFundingDisbursementSignal;
